import { Footer } from "@sikt/sds-footer";
import { Header } from "@sikt/sds-header";
import type { ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";
import styles from "./Shell.module.css";

export function Shell({ children }: { children: ReactNode }) {
  return (
    <div className={styles.shell}>
      <Header
        logoText="Stem"
        logoLink={<RouterLink className="sds-typography-link" to="/" />}
        skipLinkId="main"
      />
      <main id="main" className={styles.main}>
        {children}
      </main>
      <Footer lang="nb" />
    </div>
  );
}
